import { render } from "./bigFont.vue?vue&type=template&id=64e910f7&scoped=true"
import script from "./bigFont.vue?vue&type=script&lang=js"
export * from "./bigFont.vue?vue&type=script&lang=js"

import "./bigFont.vue?vue&type=style&index=0&id=64e910f7&lang=less&scoped=true"

import exportComponent from "E:\\上蔡\\大数据\\宽版\\shancgai2-修改农业-审计修改\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e910f7"]])

export default __exports__